import React from 'react';
import { Flex } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import SkeletonCard from 'components/SkeletonCard';

const LoaderSkeletonCard = React.memo(() => {
  return (
    <SkeletonCard p={0} width={['100%', 394]}>
      <Flex flexDirection="column" justifyContent="center">
        <Flex flexDirection="row" justifyContent="space-between">
          <Flex flexDirection="column" justifyContent="flex-start">
            <PulsingLoadingBlock height={24} width={128} borderRadius="rounded" />
          </Flex>
          <Flex flexDirection="column" justifyContent="flex-end">
            <PulsingLoadingBlock height={42} width={166} borderRadius="default" mr={0} mb={0} />
          </Flex>
        </Flex>
        <Flex flexDirection="row" alignItems="baseline" flexWrap="wrap">
          <Flex alignItems="center" mb={1}>
            <PulsingLoadingBlock height={30} width={66} borderRadius="rounded" />
            <PulsingLoadingBlock height={18} width={32} borderRadius="rounded" />
          </Flex>
        </Flex>
        <Flex flexDirection="row">
          <PulsingLoadingBlock height={18} width={42} borderRadius="rounded" mb={0} />
          <PulsingLoadingBlock height={18} width={55} borderRadius="rounded" mb={0} />
        </Flex>
      </Flex>
    </SkeletonCard>
  );
});

LoaderSkeletonCard.displayName = 'LoaderSkeletonCard';

export default LoaderSkeletonCard;
